import { stat } from "fs";

const repaycontractSearch = {
  state: {
    data: null
  },
  mutations: {
    SET_REPAYCONTRACTSEARCH: (state, repaycontractSearch) => {
      state.data = repaycontractSearch
    }
  }
}

export default repaycontractSearch



// WEBPACK FOOTER //
// ./src/store/modules/repaycontractSearch.js